export const VIRAL_CONTRIBUTORS = ['TOP_POST', 'TOP_RETWEET'];
